import React from "react";
import Control from "react-leaflet-control";
import "./MapPicker.scss";

/*
 * This component is a wrapper for the map picker that controls the background map type
 */

const MapPicker = (props) => {
  return (
    <Control className="mapPickerContainer" position="bottomright">
      {props.children}
    </Control>
  );
};

export default MapPicker;
